import { render, staticRenderFns } from "./base-code.vue?vue&type=template&id=5d71c70d&scoped=true&"
import script from "./base-code.vue?vue&type=script&lang=js&"
export * from "./base-code.vue?vue&type=script&lang=js&"
import style0 from "./base-code.vue?vue&type=style&index=0&id=5d71c70d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71c70d",
  null
  
)

export default component.exports